export default __webpack_public_path__ + "static/media/sect2_img.329d6da7.png";